module.exports = __webpack_public_path__ + "./img/jpg.6873ae52c96c78251ec6266ffc279089.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Briefcase/entry/icons/jpg.png
// module id = ./src/containers/Briefcase/entry/icons/jpg.png
// module chunks = 0